var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    { attrs: { title: _vm.title } },
    [
      _c("template", { attrs: { slot: "body" }, slot: "body" }, [
        _c(
          "form",
          {
            attrs: { novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.createMarker()
              }
            }
          },
          [
            _c(
              "sc-field",
              { attrs: { grouped: "" } },
              [
                _c("sc-input", {
                  ref: "description",
                  attrs: { placeholder: "Nome do marcador" },
                  model: {
                    value: _vm.marker.description,
                    callback: function($$v) {
                      _vm.$set(_vm.marker, "description", $$v)
                    },
                    expression: "marker.description"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "control is-clearfix" },
                  [
                    _c("sc-color-picker", {
                      attrs: {
                        "trigger-style": {
                          width: "36px",
                          height: "36px",
                          "border-radius": "5px"
                        }
                      },
                      model: {
                        value: _vm.marker.color,
                        callback: function($$v) {
                          _vm.$set(_vm.marker, "color", $$v)
                        },
                        expression: "marker.color"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("sc-field", [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      class: { "is-loading": _vm.loadingMarkerSave },
                      attrs: {
                        disabled:
                          _vm.loadingMarkerSave ||
                          !_vm.marker.description ||
                          !_vm.marker.color
                      }
                    },
                    [_vm._v("Incluir")]
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("section", { staticClass: "hero" }, [
          _c("div", { staticClass: "hero-body" }, [
            _c(
              "div",
              { staticClass: "columns" },
              _vm._l(_vm.markers, function(marker) {
                return _c(
                  "div",
                  { key: marker.id, staticClass: "column is-narrow" },
                  [
                    _c(
                      "div",
                      [
                        _c("sc-recon-marker", {
                          attrs: { marker: marker, "is-deleted": true },
                          on: { delete: _vm.deleteMarker }
                        }),
                        _vm._v(" "),
                        _c("sc-color-picker", {
                          attrs: {
                            "trigger-style": {
                              width: "100%",
                              margin: "5px 0"
                            }
                          },
                          on: {
                            input: function($event) {
                              _vm.updateMarker(marker)
                            }
                          },
                          model: {
                            value: marker.color,
                            callback: function($$v) {
                              _vm.$set(marker, "color", $$v)
                            },
                            expression: "marker.color"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              })
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2167f9ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2167f9ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/blocks/ConfigurationInvoiceMarkers.vue
// module id = null
// module chunks = 